export default __webpack_public_path__ + "static/media/help.a77bdbe1.svg";